'use client';

import { HiOutlineArrowDownTray } from 'react-icons/hi2';
import { NBA_DFS_SITES } from '@sharpr/projections';
import { Tooltip } from '@sharpr/ui';
import { BookThumbnail } from '@/components/BookThumbnail';

// The board's projections download (NBA, always shown; no projections in view → the columns only): our projections for
// the slate, with each player's DraftKings and FanDuel points (the hover names them, by the sites' logos). `viewQuery` is "?view=..." while an admin previews a lower cut, else ""; `out` the
// questionable players the viewer has marked out on the board (boardPlayerKey), so the file prices them out as the
// board does.
export function DownloadMenu({ viewQuery, out = [] }: { viewQuery: string; out?: readonly string[] }) {
  const q = new URLSearchParams(viewQuery);
  for (const key of out) q.append('out', key);
  return (
    <Tooltip content={
      <div className="flex flex-col gap-1">
        <span>Download projections (CSV)</span>
        <span className="flex items-center gap-1.5">
          With fantasy points for
          {NBA_DFS_SITES.map(site => <BookThumbnail key={site} book={site} size="sm" />)}
        </span>
      </div>
    }>
      <a href={`/api/projections/nba/csv${q.size > 0 ? `?${q}` : ''}`} download aria-label="Download projections"
        className="inline-flex items-center px-2.5 md:px-2 py-1.5 md:py-2 rounded-full border transition-all duration-200 active:scale-95 motion-reduce:active:scale-100 bg-white dark:bg-bg-tertiary text-gray-600 dark:text-text-secondary border-gray-200 dark:border-border-primary hover:border-gray-400 dark:hover:border-border-interactive">
        <HiOutlineArrowDownTray aria-hidden="true" className="w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0" />
      </a>
    </Tooltip>
  );
}
